export const disabledButtonStyle = {
  color: 'rgba(0, 0, 0, 0.26)',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  WebkitTextFillColor: 'rgba(0, 0, 0, 0.26)',
  ':hover': {
    color: 'rgba(0, 0, 0, 0.26)',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    WebkitTextFillColor: 'rgba(0, 0, 0, 0.26)',
    backgroundColor: 'rgba(0, 0, 0, 0)',
  },
};

export const disabledStyle = {
  color: 'rgba(0, 0, 0, 0.26)',
  WebkitTextFillColor: 'rgba(0, 0, 0, 0.26)',
  ':hover': {
    color: 'rgba(0, 0, 0, 0.26)',
    WebkitTextFillColor: 'rgba(0, 0, 0, 0.26)',
    backgroundColor: 'rgba(0, 0, 0, 0)',
  },
};
